import React, { useEffect } from 'react';
import { Marker, Polyline, Popup } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import {
    isMeasuringToolDeleteClickedState,
    isSlopeServiceActiveState,
    isUsingMeasuringToolState,
    polylineDistanceTooltipCoordsState,
} from '../../../../app/redux/retrievers/retrievers';
import { calculateSlope, calculateSlopeDirection, getDistance } from '../../../../core/utils/map.utils';
import { setPolylineDistanceTooltipCoords } from '../../../../app/redux/slices/PolylineDistanceTooltipCoordsSlice';
import { slopeDirectionTextSetter } from './functions/slopeDirectionTextSetter';

const MeasuringTool = () => {
    const dispatch = useDispatch();
    const polylineDistanceTooltipCoords = useSelector(polylineDistanceTooltipCoordsState);
    const isUsingMeasuringTool = useSelector(isUsingMeasuringToolState);
    const isMeasuringToolDeleteClicked = useSelector(isMeasuringToolDeleteClickedState);
    const isSlopeServiceActive = useSelector(isSlopeServiceActiveState);

    useEffect(() => {
        if (isMeasuringToolDeleteClicked) {
            dispatch(setPolylineDistanceTooltipCoords([]));
        }
    }, [isMeasuringToolDeleteClicked]);

    return (
        <>
            {isUsingMeasuringTool &&
                polylineDistanceTooltipCoords.map((item: any) => {
                    if (item && item.coords && item.coords.length > 0) {
                        let twoPointLineMeters = 0;
                        let multiPointLineMeters = 0;
                        // if (item.coords.length === 2) {
                        twoPointLineMeters = getDistance(
                            [item.coords[0].lng, item.coords[0].lat],
                            [item.coords[item.coords.length - 1].lng, item.coords[item.coords.length - 1].lat],
                        );

                        let slope = calculateSlope(item.coords[0], item.coords[1]);
                        let slopeDirection = calculateSlopeDirection(item.coords[0], item.coords[1]);
                        const slopeDirectionText = slopeDirectionTextSetter(slopeDirection.direction);
                        // }
                        // else {
                        //     multiPointLineMeters = getLength(item.coords);
                        // }

                        return (
                            <>
                                <Polyline positions={item.coords} color="red" dashArray="5" />
                                <Popup
                                    key={item.coords[0].lng}
                                    position={item.coords[0]}
                                    className="measure-tooltip"
                                    closeButton={false}
                                    autoClose={false}
                                    closeOnClick={false}
                                >
                                    <div style={{ marginRight: -20, padding: 5, paddingLeft: 0, textAlign: 'right' }}>
                                        <div>
                                            <span>فاصله</span>
                                            <span> :</span>
                                            <span style={{ fontWeight: 'bold' }}> {twoPointLineMeters.toFixed(2)}</span>
                                            <span> متر</span>
                                        </div>
                                        {isSlopeServiceActive && (
                                            <>
                                                <div>
                                                    {/* <span>{slope.slopePercentage > 0 ? '' : '-'}</span> */}
                                                    <span>درصد شیب</span>
                                                    <span> :</span>
                                                    <span style={{ fontWeight: 'bold' }}>
                                                        {' '}
                                                        %{Math.abs(slope.slopePercentage).toFixed(2)}
                                                    </span>
                                                </div>
                                                <div>
                                                    {/* <span>{slope.slopeAngle > 0 ? '' : '-'}</span> */}
                                                    <span>درجه شیب</span>
                                                    <span> :</span>
                                                    <span style={{ fontWeight: 'bold' }}>
                                                        {' '}
                                                        °{Math.abs(slope.slopeAngle).toFixed(2)}
                                                    </span>
                                                </div>
                                                {slopeDirection.direction != '' && (
                                                    <>
                                                        <div>
                                                            <span>جهت شیب</span>
                                                            <span> :</span>{' '}
                                                            <span style={{ fontWeight: 'bold' }}>{slopeDirectionText}</span>
                                                        </div>
                                                        <div>
                                                            <span>درجه جهت</span>
                                                            <span> :</span> <span>°</span>
                                                            <span style={{ fontWeight: 'bold' }}>
                                                                {slopeDirection.degree.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </Popup>
                            </>
                        );
                    }
                })}
        </>
    );
};

export default MeasuringTool;
